import { render } from "./ProfileSettingsVerifyImagePage.vue?vue&type=template&id=4d9fe27e&ts=true"
import script from "./ProfileSettingsVerifyImagePage.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsVerifyImagePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__